import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = {
  key: 0,
  class: "app-config-loader flex-column justify-content-center align-items-center d-flex"
}
const _hoisted_3 = { class: "text-muted loading-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BImg = _resolveComponent("BImg")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mode !== 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.mode === 0 || _ctx.mode === 2)
            ? (_openBlock(), _createBlock(_component_BImg, {
                key: 0,
                src: "/loading.gif",
                fluid: "",
                alt: "Responsive image",
                width: "400",
                height: "300"
              }))
            : _createCommentVNode("", true),
          (_ctx.mode === 3)
            ? (_openBlock(), _createBlock(_component_BImg, {
                key: 1,
                src: "/500.svg",
                fluid: "",
                alt: "Responsive image",
                width: "250",
                class: "pb-5 mb-5"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.modeMessage) + ".", 1)
        ]))
      : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
  ]))
}